const vcitaAppLinks = {
  ios: 'https://itunes.apple.com/app/vcita-mobile-crm/id1025423769?mt=8',
  android: 'http://bit.ly/1PiUDGx'
}

const state = {
  appLink: null
}
const getters = {
  getAppLink: state => state.appLink
}
const mutations = {
  setAppLink(state, link) {
    state.appLink = link
  },
}
const actions = {
  initMobileAppDownloadLink({commit, rootGetters}) {
    let os = rootGetters.isIOS ? 'ios' : 'android'
    let account = rootGetters["accountModule/account"]
    if ((account.whitelabel || account?.business?.managed_co_branded) && account?.brand?.mobile_app_name) {
      commit('setAppLink', account?.brand[`mobile_app_${os}`])
    } else if (!account.whitelabel) {
      commit('setAppLink', vcitaAppLinks[os])
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
